module.exports = __webpack_public_path__ + "media/Blob 10 Joins.0566ea68.mp3";